<div class="modal-header">
  <div class="divHeader">
    <h4 class="modal-title pull-left">{{title}}</h4>
    <span class="header">{{header}}</span>
  </div>
  <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
    <span style="font-weight: bold;" aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
</div>
<div class="modal-footer divButtons">
  <button type="button" class="buttonConfirm btn" id="confirm" (click)="  confirmarSemPlano()">Seguir sem Plano ou Agrupador</button>
  <button type="button" class="buttonConfirm btn" id="confirm" (click)="  cancelar()">Voltar</button>
</div>